module.exports = __webpack_public_path__ + "img/cover_stigler.9430d149.jpg";